// extracted by mini-css-extract-plugin
export var circles = "Reviews-module--circles--562c0";
export var container = "Reviews-module--container--54b82";
export var heading = "Reviews-module--heading--8143f";
export var item = "Reviews-module--item--4b600";
export var items = "Reviews-module--items--e0454";
export var marquee = "Reviews-module--marquee--0dbe3";
export var section = "Reviews-module--section--4500f";